// import React from "react";
// import AsnListGR from "./AsnListGR";
// import ASNManagement from "../asn/ASNManagement";

// export default function GoodsReceipt({ initialGrnNumber, onBack, initialGrnId }) {
//   const [deeplinkAsn, setDeeplinkAsn] = React.useState(null);

//   const isGrnDeepLinkView = Boolean(initialGrnNumber) && !deeplinkAsn;


//   console.log(
//     "GoodsReceipt initialGrnNumber................initialGrnNumber:",
//     initialGrnNumber
//   );

//   return (
//     <div className="card shadow-lg main-card" style={{ position: "relative" }}>

     
//       {!isGrnDeepLinkView && (
//         <div className="card-header bg-secondary text-white">
//           <h4 className="mb-0 h6 fw-semibold">
//             {deeplinkAsn ? `View ASN ${deeplinkAsn}` : "Goods Receipt"}
//           </h4>
//         </div>
//       )}

    
//       {!isGrnDeepLinkView && (
//         <nav aria-label="breadcrumb" className="px-3 border-bottom bg-light mb-2">
//           <ol className="breadcrumb mb-0 align-items-center">
          
//             {initialGrnNumber && !deeplinkAsn && (
//               <li
//                 className="breadcrumb-item active fw-semibold text-primary"
//                 aria-current="page"
//               >
//                 {initialGrnNumber}
//               </li>
//             )}

        
//             {deeplinkAsn && (
//               <>
//                 <li className="breadcrumb-item">
//                   <button
//                     type="button"
//                     className="btn btn-link p-0 text-decoration-none text-muted"
//                     onClick={() => setDeeplinkAsn(null)} // back to GRN list/details
//                   >
//                     Goods Receipt
//                   </button>
//                 </li>
//                 <li
//                   className="breadcrumb-item active fw-semibold text-primary"
//                   aria-current="page"
//                 >
//                   View ASN {deeplinkAsn}
//                 </li>
//               </>
//             )}
//           </ol>
//         </nav>
//       )}

//       <div className="card-body">
//         {deeplinkAsn ? (
//           <ASNManagement
//             initialAsnNumber={String(deeplinkAsn)}
//             onCancel={() => setDeeplinkAsn(null)}
//             onDeepLinkNotFound={() => setDeeplinkAsn(null)}
//           />
//         ) : (
//           <AsnListGR
//             initialGrnNumber={initialGrnNumber}
//             onOpenAsn={(asnNo) => setDeeplinkAsn(asnNo)}
//             initialGrnId={initialGrnId}
//             onBack={onBack}
//           />
//         )}
//       </div>
//     </div>
//   );
// }







// GoodsReceipt.jsx
import React from "react";
import AsnListGR from "./AsnListGR";
import ASNManagement from "../asn/ASNManagement";
import { useTranslation } from "react-i18next";
import AddGRN from "./AddGRN";
import "./goods-receipt.css";

export default function GoodsReceipt({ initialGrnNumber, onBack, initialGrnId }) {
  const [deeplinkAsn, setDeeplinkAsn] = React.useState(null);
  const { t } = useTranslation();
  const [isCreatingGRN, setIsCreatingGRN] = React.useState(false);

  const isGrnDeepLinkView = Boolean(initialGrnNumber) && !deeplinkAsn;

  console.log(
    "GoodsReceipt initialGrnNumber................initialGrnNumber:",
    initialGrnNumber
  );

  return (
    <div className="card shadow-lg main-card" style={{ position: "relative" }}>
      {/* Header with language switcher */}
      {!isGrnDeepLinkView && (
        <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0 h6 fw-semibold">
            {deeplinkAsn
              ? t("goodsReceipt.viewAsnTitle", { asn: deeplinkAsn })
              : isCreatingGRN
              ? "Create GRN"
              : t("goodsReceipt.title")}
          </h4>
        </div>
      )}

      {!isGrnDeepLinkView && (isCreatingGRN || initialGrnNumber || deeplinkAsn) && (
        <nav aria-label="breadcrumb" className="px-3 py-2 border-bottom bg-light mb-2">
          <ol className="breadcrumb mb-0 align-items-center">
            {isCreatingGRN && (
              <>
                <li className="breadcrumb-item">
                  <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none text-muted"
                    onClick={() => {
                      setIsCreatingGRN(false);
                    }}
                  >
                    {t("goodsReceipt.breadcrumb.goodsReceipt")}
                  </button>
                </li>
                <li className="breadcrumb-item active fw-semibold text-primary" aria-current="page">
                  Create GRN
                </li>
              </>
            )}

            {initialGrnNumber && !deeplinkAsn && !isCreatingGRN && (
              <li
                className="breadcrumb-item active fw-semibold text-primary"
                aria-current="page"
              >
                {initialGrnNumber}
              </li>
            )}

            {deeplinkAsn && (
              <>
                <li className="breadcrumb-item">
                  <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none text-muted"
                    onClick={() => setDeeplinkAsn(null)}
                  >
                    {t("goodsReceipt.breadcrumb.goodsReceipt")}
                  </button>
                </li>
                <li
                  className="breadcrumb-item active fw-semibold text-primary"
                  aria-current="page"
                >
                  {t("goodsReceipt.breadcrumb.viewAsn", { asn: deeplinkAsn })}
                </li>
              </>
            )}
          </ol>
        </nav>
      )}

      <div className="card-body">
        {isCreatingGRN ? (
          <AddGRN onCancel={() => setIsCreatingGRN(false)} />
        ) : (
          <>
            {deeplinkAsn ? (
              <ASNManagement
                initialAsnNumber={String(deeplinkAsn)}
                onCancel={() => setDeeplinkAsn(null)}
                onDeepLinkNotFound={() => setDeeplinkAsn(null)}
              />
            ) : (
              <AsnListGR
                initialGrnNumber={initialGrnNumber}
                onOpenAsn={(asnNo) => setDeeplinkAsn(asnNo)}
                initialGrnId={initialGrnId}
                onBack={onBack}
                showCreateButton={true}
                createButtonText="Create New GRN"
                onCreateClick={() => setIsCreatingGRN(true)}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
